import { createContext } from 'react';

type ChargingStationsActions = 'add' | 'edit' | 'delete';

export const ChargingStationsActionsContext = createContext<
  ChargingStationsActions[]
>(['add', 'edit', 'delete']);
